import { faCircleMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { type FC, useState } from "react";
import { useApiCall, ValidationError } from "../api/api";
import type { Inspection } from "../api/dto/Inspection";
import { Button, IconButton } from "../components/form/Button";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";

export const SendSharedInspectionFindingModal: FC<{
  inspection: Inspection;
  default: { email: string; name: string }[];
  onFinish?: () => void;
}> = (props) => {
  const { sendSharedInspectionFindings } = useApiCall();
  const [recepients, setRecepients] = useState<{ email: string; name: string }[]>(
    props.default?.length ? props.default : [{ name: "", email: "" }],
  );
  const [errors, setErrors] = useState<string[]>([]);

  const update = (idx: number, changes: Partial<{ email: string; name: string }>) =>
    setRecepients(recepients.map((r, i) => (i === idx ? { ...r, ...changes } : r)));

  const remove = (idx: number) => setRecepients(recepients.filter((_, i) => i !== idx));

  const save = async () => {
    try {
      await sendSharedInspectionFindings(props.inspection.id, recepients);
      props.onFinish?.();
    } catch (e) {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
        return;
      }
      throw e;
    }
  };

  return (
    <div className={"Bevinding delen"}>
      <div className={"flex flex-col gap-3"}>
        <table className={"w-full"}>
          <thead>
            <tr className={"text-left text-sm"}>
              <th className={"pb-1 font-medium"}>Name</th>
              <th className={"pb-1 font-medium"}>Email</th>
              <th className={"w-10"} />
            </tr>
          </thead>
          <tbody>
            {recepients.map((recepient, idx) => (
              <tr key={idx}>
                <td className={"pr-2 py-1"}>
                  <Input
                    type={"text"}
                    label={""}
                    value={recepient.name}
                    onChange={(name) => update(idx, { name })}
                  />
                </td>
                <td className={"pr-2 py-1"}>
                  <Input
                    type={"email"}
                    label={""}
                    value={recepient.email}
                    onChange={(email) => update(idx, { email })}
                  />
                </td>
                <td className={"py-1"}>
                  {recepients.length > 1 && (
                    <IconButton
                      type={"danger"}
                      size={"md"}
                      icon={faCircleMinus}
                      onClick={() => remove(idx)}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className={"flex"}>
          <Button
            type="secondary"
            size="sm"
            icon={faPlus}
            text="extra email"
            onClick={() => setRecepients([...recepients, { name: "", email: "" }])}
          />
        </div>

        <div className="text-red-600 text-sm">
          {errors.map((e) => (
            <p key={e}>{e}</p>
          ))}
        </div>
      </div>
      <ModalFooter
        text={"Opslaan"}
        onSubmit={save}
        disabled={
          !!recepients.find((r) => r.name.trim().length === 0 || r.email.trim().length === 0)
        }
      />
    </div>
  );
};
